import {LngLat} from 'mapbox-gl';

export default function convertLngLat(input: mapboxgl.LngLatLike | number[]): mapboxgl.LngLat {
    if (Array.isArray(input)) {
        return LngLat.convert([input[0], input[1]]);
    } else {
        return LngLat.convert(input);
    }
}
